import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CommandBar } from '@fluentui/react';
import { api } from '../services/api';
import styles from './InstanceEmbed.module.css';

export default function InstanceEditor() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;

    api.getProxyToken(id).then(({ token }) => {
      if (cancelled) return;
      const url = `https://proxy.agentbox.networg.com/instances/${id}/editor/?proxy_token=${encodeURIComponent(token)}`;
      setIframeSrc(url);
    }).catch(err => {
      if (!cancelled) setError(err.message);
    });

    return () => { cancelled = true; };
  }, [id]);

  const commandBarItems = [
    { key: 'back', iconOnly: true, iconProps: { iconName: 'Back' }, onClick: () => { navigate(`/instances/${id}`); }, ariaLabel: 'Back' },
    { key: 'title', text: `VS Code — #${id}`, disabled: true },
  ];

  return (
    <div className={styles.container}>
      <CommandBar items={commandBarItems} styles={{ root: { borderBottom: '1px solid var(--ab-border)', background: 'var(--ab-bg-command-bar)', padding: '0 8px', flexShrink: 0 } }} />
      {error ? (
        <p style={{ padding: 20 }}>Failed to authenticate: {error}</p>
      ) : !iframeSrc ? (
        <p style={{ padding: 20 }}>Authenticating…</p>
      ) : (
        <iframe src={iframeSrc} className={styles.frame} title={`Editor — ${id}`} />
      )}
    </div>
  );
}
